// utils/formatLargeNumber.ts

/**
 * Format a large number with a suffix (K, M, B, T, Q) and up to 2 decimals.
 * Examples:
 *   1234 => "1.23K"
 *   1000000 => "1M"
 *   2500000000 => "2.5B"
 *   100 => "100"
 */
export function formatLargeNumber(num: number | string, digits = 2): string {
  if (typeof num === "string") num = Number(num);
  if (isNaN(num)) return "-";
  const absNum = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (absNum >= 1e15) return sign + (absNum / 1e15).toFixed(digits) + "Q"; // Quadrillion
  if (absNum >= 1e12) return sign + (absNum / 1e12).toFixed(digits) + "T"; // Trillion
  if (absNum >= 1e9)  return sign + (absNum / 1e9).toFixed(digits) + "B"; // Billion
  if (absNum >= 1e6)  return sign + (absNum / 1e6).toFixed(digits) + "M"; // Million
  if (absNum >= 1e3)  return sign + (absNum / 1e3).toFixed(digits) + "K"; // Thousand
  return sign + absNum.toLocaleString();
}
